export enum TypeEncaissement {
  PARTIEL = 'partiel',
  TOTALITE = 'totalite',
}

export enum MotifEncaissement {
  PAIEMENT_FACTURE = 'paiement_facture',
  AVANCE_DEVIS = 'avance_devis',
}

export enum StatusEncaissement {
  EN_COURS = 'en_cours',
  ENCAISSE = 'encaisse',
  IMPAYE = 'impaye',
}

export interface Encaissement {
  id: number;
  reference: string;
  date: string;
  client_id: number | null;
  client_name?: string | null;
  service_id: number | null;
  service_name?: string | null;
  mode_paiement_id: number | null;
  mode_paiement_nom?: string | null;
  reference_paiement?: string | null;
  type_encaissement: string;
  motif_encaissement: string;
  facture_id: number | null;
  facture_reference?: string | null;
  devis_id: number | null;
  devis_reference?: string | null;
  projet_id: number | null;
  projet_nom?: string | null;
  libelle?: string | null;
  montant_encaisse: number;
  reste: number | null;
  status: string;
  date_echeance?: string | null;
  user_id: number;
  user_name?: string | null;
  created_at?: string | null;
  updated_at?: string | null;
  deleted_at?: string | null;
}

export interface EncaissementCreate {
  date: string;
  client_id?: number | null;
  service_id?: number | null;
  mode_paiement_id?: number | null;
  reference_paiement?: string | null;
  type_encaissement: string;
  motif_encaissement: string;
  facture_id?: number | null;
  devis_id?: number | null;
  projet_id?: number | null;
  libelle?: string | null;
  montant_encaisse: number;
  reste?: number | null;
  status?: string;
  date_echeance?: string | null;
}

export interface EncaissementUpdate {
  date?: string;
  client_id?: number | null;
  service_id?: number | null;
  mode_paiement_id?: number | null;
  reference_paiement?: string | null;
  type_encaissement?: string;
  motif_encaissement?: string;
  facture_id?: number | null;
  devis_id?: number | null;
  projet_id?: number | null;
  libelle?: string | null;
  montant_encaisse?: number;
  reste?: number | null;
  status?: string;
  date_echeance?: string | null;
}

export interface EncaissementListResponse {
  total: number;
  total_montant: number;
  items: Encaissement[];
}

export interface FactureImpayee {
  id: number;
  reference: string;
  date: string;
  total_net: number;
  status: string;
  designations: string;
}
